import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/library/accordion";
import { GraduationCap, Building2, BookOpen } from "lucide-react";
import { useEduChildModuleData } from "@/module/education/helpers/useEduChildModuleData";

function InfoField({
  icon: Icon,
  label,
  value,
}: {
  icon: React.ElementType;
  label: string;
  value: string;
}) {
  return (
    <div className="flex items-start gap-2.5 rounded-xl bg-[#f5f7f6] px-3 py-2.5">
      <div className="flex size-7 shrink-0 items-center justify-center rounded-lg bg-white">
        <Icon size={14} className="text-[#505e59]" />
      </div>
      <div className="flex flex-col gap-0.5 min-w-0">
        <span className="text-[11px] font-medium uppercase tracking-[0.5px] text-[#8a918d]">
          {label}
        </span>
        <span className="text-[13px] font-medium text-[#1e302a] tracking-[-0.26px] truncate">
          {value || "—"}
        </span>
      </div>
    </div>
  );
}

export function ChoiceInfo({ child }: any) {
  const { universityName, courseName } = useEduChildModuleData(child);
  const choiceName = child?.name;

  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="choice-info" className="border-none">
        <AccordionTrigger className="text-b2-mid font-medium hover:no-underline px-0 py-3 justify-start! gap-2 items-center [&>svg]:translate-y-0">
          Choice Info
        </AccordionTrigger>
        <AccordionContent className="px-0 pb-0">
          <div className="flex flex-col gap-2">
            <InfoField
              icon={GraduationCap}
              label="Choice Name"
              value={choiceName}
            />
            <div className="grid grid-cols-2 gap-2">
              <InfoField
                icon={Building2}
                label="University"
                value={universityName}
              />
              <InfoField
                icon={BookOpen}
                label="Course / Program"
                value={courseName}
              />
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
